import { useState } from 'react';
import { logger } from '../utils/logger';

export const useShare = () => {
  const [isSharing, setIsSharing] = useState(false);

  const shareUrl = async (url, text, title) => {
    setIsSharing(true);
    try {
      // Vérifier si l'API Web Share est disponible
      if (navigator.share) {
        await navigator.share({
          text: `${text}\n${title}\n${url}`
        });
        return true;
      } else {
        // Fallback pour desktop
        const shareUrls = {
          whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text}\n${title}\n${url}`)}`,
          twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${text}\n${title}`)}&url=${encodeURIComponent(url)}`,
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
        };

        // Ouvrir dans une nouvelle fenêtre
        window.open(shareUrls.whatsapp, '_blank', 'width=550,height=400');
        return true;
      }
    } catch (error) {
      logger.error('Erreur lors du partage:', error);
      return false;
    } finally {
      setIsSharing(false);
    }
  };

  return {
    shareUrl,
    isSharing
  };
}; 